export const scaleEnum = {
  18: '18㎡',
  27: '27㎡',
  36: '36㎡',
  45: '45㎡',
  54: '54㎡',
  63: '63㎡',
  72: '72㎡',
  81: '81㎡',
  90: '其他',
}
